import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { loginRequest } from 'auth-config';
import { useMsal } from '@azure/msal-react';
import { useDispatch } from 'react-redux';
import HenkelLog from 'assets/images/henkel-logo-standalone-svg.svg';
import AiHubLogin from 'assets/images/AiHub_Login.svg';
import LoginFooter from './components/login-footer';
import { setToken } from 'utils/token-kit.js';
import { setUser } from '../../redux/user';
import * as api from '../../api';

import './index.css';
const Login = () => {
	const navigate = useNavigate();
	const { instance } = useMsal();
	const location = useLocation();
	const dispatch = useDispatch();
	const initialized = useRef(false);

	useEffect(() => {
		instance.handleRedirectPromise().then(() => {
			if (instance.getAllAccounts().length > 0 && !initialized.current) {
				tryToInitialize();
			}
		});
	}, [location]);
	function tryToInitialize() {
		const accounts = instance.getAllAccounts();
		let activeAccount = instance.getActiveAccount();

		if (accounts.length > 0) {
			if (!activeAccount) {
				instance.setActiveAccount(accounts[0]);
			}
			activeAccount = instance.getActiveAccount();
			if (activeAccount) {
				const token = activeAccount.idToken;
				setToken(token);
			}
			try {
				api.getProfile().then((response) => {
					if (response && response.responseData) {
						dispatch(setUser(response.responseData));
						navigate('/');
					}
				});
			} catch (error) {
				console.error('Failed to get user profile:', error);
			}
			initialized.current = true;
		} else {
			localStorage.clear();
		}
	}
	function onLoginButtonClick() {
		instance.loginRedirect(loginRequest);
		// .then((response) => {
		// })
		// .catch((e) => {
		// 	localStorage.clear();
		// 	navigate('/login');
		// });
	}

	return (
		<div className="container login-container">
			<div className="login-con content-half ">
				<div className="login-main-news">
					<div className="login-main-con">
						<div>
							<img className="banklog" src={HenkelLog} />
							<div className="login-to">Login to</div>
							<div className="henkel-ai">Henkel AI Hub</div>
						</div>
						<div className="login-main">
							<div className="login-btn" onClick={() => onLoginButtonClick('redirect')}>
								Login With Henkel Azure AD
							</div>
						</div>
					</div>
				</div>
				<div className="login-main-footer">
					<LoginFooter />
				</div>
			</div>
			<div className="content-half right">
				<img className="ai-hub-login" src={AiHubLogin} alt=""></img>
			</div>
		</div>
	);
};
export default Login;
